import axios from 'axios';

export const authService = {
    /** Goals */

    getGoalsService: (params) => axios.get(`/clinical/goals`, { auth: true, params: { ...params } }),

    getGoalsForSessionService: (clientId, params) => axios.get(`/clinical/goals/session/client/${clientId}`, { auth: true, params }),

    getSimpleGoalsService: (clientId, params) =>
        axios.get(`/clinical/progress-report/goal/client/${clientId}`, { auth: true, params: { ...params } }),

    getGoalByIdService: (id) => axios.get(`/clinical/goals/${id}`, { auth: true }),

    createGoalService: (body) => axios.post(`/clinical/goals`, body, { auth: true }),

    editGoalService: (id, body) => axios.patch(`/clinical/goals/${id}`, body, { auth: true }),

    upsertSectionDescriptionBlockService: (goalId, body) =>
        axios.post(`/clinical/goals/${goalId}/section-description-block`, body, { auth: true }),

    deleteSectionDescriptionBlockService: (goalId, sectionTypeId) =>
        axios.delete(`/clinical/goals/${goalId}/section-description-block/${sectionTypeId}`, { auth: true }),

    reorderSectionDescriptionBlocksService: (goalId, reorder) =>
        axios.patch(`/clinical/goals/${goalId}/section-description-block/reorder`, reorder, { auth: true }),

    getSectionTypesService: () => axios.get(`/clinical/sectionType`, { auth: true }),

    createSectionTypeService: (body) => axios.post(`/clinical/sectionType`, body, { auth: true }),

    editSectionTypeService: (id, body) => axios.post(`/clinical/sectionType/${id}`, body, { auth: true }),

    editGoalStatusService: (id, status) =>
        axios.post(
            `/clinical/goals/${id}/status`,
            {},
            {
                auth: true,
                params: status,
            }
        ),

    deleteGoalService: (id) => axios.delete(`/clinical/goals/${id}`, { auth: true }),

    restoreGoalService: (id) => axios.patch(`/clinical/goals/${id}/restore`, {}, { auth: true }),

    cloneGoalService: (id, params) => axios.post(`/clinical/goals/${id}/clone`, params || {}, { auth: true }),

    getGoalSessionsService: (id) => axios.get(`/clinical/sessions/goal/${id}`, { auth: true }),

    getGoalGraphService: (id, params) => axios.get(`/clinical/goals/graph/${id}`, { auth: true, params: params }),

    getGoalTrialDataService: (goalId, sessionId) => axios.get(`/clinical/sessions/goal/${goalId}/tSummary/${sessionId}`, { auth: true }),

    chooseGoalsFromLibraryService: (body) =>
        axios.post(`/clinical/goals/copy`, body, {
            auth: true,
        }),

    chooseTargetsFromLibraryService: (goalId, body) =>
        axios.post(`/clinical/goals/${goalId}/targets/copy`, body, {
            auth: true,
        }),

    chooseOptionsFromLibraryService: (goalId, body) =>
        axios.post(`/goals/${goalId}/options/copy`, body, {
            auth: true,
        }),
    /** End */

    /** Targets */

    createTargetService: (goalId, body) => axios.post(`/clinical/goals/${goalId}/targets`, body, { auth: true }),

    editTargetService: (goalId, targetId, body) => axios.patch(`/clinical/goals/${goalId}/targets/${targetId}`, body, { auth: true }),

    /** Moves the date of the target's latest status transition (`{ date }`, ISO instant). Returns the goal. */
    editTargetTransitionDateService: (goalId, targetId, body) =>
        axios.patch(`/clinical/goals/${goalId}/targets/${targetId}/last-transition`, body, { auth: true }),

    reorderTargetService: (goalId, reorder) => axios.patch(`/clinical/goals/${goalId}/targets/reorder`, reorder, { auth: true }),

    getTargetChartDataService: (clientId, params) =>
        axios.get(`/clinical/goals/target/graph/${clientId}`, {
            auth: true,
            params: params,
        }),

    /** End */

    /** Options */

    createOptionService: (goalId, body) => axios.post(`/goals/${goalId}/options`, body, { auth: true }),

    editOptionService: (goalId, optionId, body) => axios.patch(`/goals/${goalId}/options/${optionId}`, body, { auth: true }),

    deleteOptionService: (goalId, optionId) => axios.delete(`/goals/${goalId}/options/${optionId}`, { auth: true }),

    restoreOptionService: (goalId, optionId) => axios.patch(`/goals/${goalId}/options/${optionId}/restore`, {}, { auth: true }),

    reorderOrderService: (goalId, reorder) => axios.patch(`/goals/${goalId}/options/reorder`, reorder, { auth: true }),

    /** End */

    /** Mastery */

    changeTargetMasteryService: (goalId, body) => axios.patch(`/clinical/goals/${goalId}/targets/mastery`, body, { auth: true }),

    changeGoalMasteryService: (goalId, body) => axios.patch(`/clinical/goals/${goalId}/goal/mastery`, body, { auth: true }),

    changeSingleTargetMasteryService: (goalId, targetId, body) =>
        axios.patch(`/clinical/goals/${goalId}/targets/${targetId}/mastery`, body, { auth: true }),

    singleTargetMasteryFollowGoalService: (goalId, targetId, body) =>
        axios.post(`/clinical/goals/${goalId}/targets/${targetId}/follow-goal-config`, body, { auth: true }),

    removeSingleTargetMasteryService: (goalId, targetId) =>
        axios.patch(`/clinical/goals/${goalId}/targets/${targetId}/mastery/setDefault`, {}, { auth: true }),

    /** Baseline -> Teaching criteria */

    changeBaselineCriteriaService: (goalId, body) =>
        axios.patch(`/clinical/goals/${goalId}/baseline/criteria`, body, { auth: true }),

    changeSingleTargetBaselineCriteriaService: (goalId, targetId, body) =>
        axios.patch(`/clinical/goals/${goalId}/targets/${targetId}/baseline-criteria`, body, { auth: true }),

    singleTargetBaselineFollowGoalService: (goalId, targetId, body) =>
        axios.post(`/clinical/goals/${goalId}/targets/${targetId}/baseline-follow-config`, body, { auth: true }),

    removeSingleTargetBaselineCriteriaService: (goalId, targetId) =>
        axios.patch(`/clinical/goals/${goalId}/targets/${targetId}/baseline-criteria/setDefault`, {}, { auth: true }),

    changeSingleTargetMaintenanceService: (goalId, targetId, body) =>
        axios.post(`/clinical/maintenance/${goalId}/${targetId}`, body, { auth: true }),

    addSingleTargetMaintenanceStepService: (goalId, targetId, body) =>
        axios.post(`/clinical/maintenance/${goalId}/target/${targetId}/step`, body, { auth: true }),

    editSingleTargetMaintenanceStepService: (goalId, stepId, body) =>
        axios.patch(`/clinical/maintenance/${goalId}/${stepId}`, body, { auth: true }),

    singleTargetFollowGoalConfigService: (goalId, targetId, body) =>
        axios.post(`/clinical/maintenance/${goalId}/${targetId}/follow-goal-config`, body, { auth: true }),

    deleteSingleTargetMaintenanceStepService: (goalId, targetId, stepId) =>
        axios.delete(`/clinical/maintenance/${goalId}/target/${targetId}/step/${stepId}`, { auth: true }),

    changeMaintenanceStepService: (goalId, params) => axios.patch(`/clinical/maintenance/${goalId}/stepNumber`, params, { auth: true }),

    /** End */

    /** Target Maintenance */

    changeTargetMaintenanceService: (goalId, body) => axios.post(`/clinical/maintenance/${goalId}`, body, { auth: true }),

    addTargetMaintenanceStepService: (goalId, body) => axios.post(`/clinical/maintenance/${goalId}/step`, body, { auth: true }),

    editTargetMaintenanceStepService: (goalId, stepId, body) =>
        axios.patch(`/clinical/maintenance/${goalId}/${stepId}`, body, { auth: true }),

    deleteTargetMaintenanceStepService: (goalId, stepId) => axios.delete(`/clinical/maintenance/${goalId}/step/${stepId}`, { auth: true }),

    /** End */

    /** Goal Clinical Data */

    getGoalCumulativeService: (params) => axios.get(`/clinical/progress-report/goal/cumulative-graph`, { auth: true, params: params }),

    getGoalTargetClinicalDataService: (params, clientId) =>
        axios.get(`/clinical/progress-report/goal/target/graph/grouped/${clientId}`, { auth: true, params: params }),

    getGoalClinicalDefaultValuesService: (params) =>
        axios.get(`/clinical/progress-report/goal/default-values`, { auth: true, params: params }),

    /** End */
};
